'use strict';

require('../core/core');
require('../../modules/pagination/pagination');
require('../../modules/forms/forms');
require('../../modules/ui/events-calendar/events-calendar');

require('../../helpers/show-modal-message/show-modal-message');

require('../documents/documents.module');
require('../../models/committee/committee');
require('../../redactor/redactor.js');
require('../../redactor/lang/ru.js');


angular.module('far.committee', [
	'ngTouch',
	'angularFileUpload',
	'ui.select',
	'ui.bootstrap',
	'dekky.pagination',
	'dekky.forms',
	'far.models.rank',
	'far.models.rankSeason',
	'far.core',
	'far.models.committee',
	'far.helpers.showModalMessage',
    'far.ui.eventsCalendar',
	'templates',
	'far.documents.search'
]).value('formsConfig', {
	theme: '/dekky.forms/themes/far'
});